import { useTranslation } from 'react-i18next';
import './FAQ.css';

const ITEMS = ['where', 'tenant', 'languages', 'pricing', 'export'] as const;

export function FAQ() {
  const { t } = useTranslation();

  return (
    <section id="faq" className="section section--soft">
      <div className="container container-narrow">
        <div className="section-header">
          <span className="eyebrow">{t('faq.eyebrow')}</span>
          <h2>{t('faq.title')}</h2>
        </div>
        <div className="faq-list">
          {ITEMS.map((key) => (
            <details key={key} className="faq-item">
              <summary className="faq-item__q">
                {t(`faq.items.${key}.q`)}
                <svg className="faq-item__chev" width="14" height="14" viewBox="0 0 12 12" fill="none" aria-hidden="true">
                  <path d="M2 4l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </summary>
              <p className="faq-item__a">{t(`faq.items.${key}.a`)}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
